const PREDEFINED_CUSTOM_ENDPOINTS = [
    {
      label: "First Name",
      lookupKey: "first_name",
      description: "Collect first name of the client.",
      required: true,
    },
    {
      label: "Last Name",
      lookupKey: "last_name",
      description: "Collect last name of the client.",
      required: true,
    },
    {
      label: "Email",
      lookupKey: "email",
      description: "Collect contact email of the client.",
      required: true,
    },
    {
      label: "Phone Number",
      lookupKey: "phone",
      description: "Collect contact phone number of the client.",
      required: true,
    },
    {
      label: "Additional Details",
      lookupKey: "additional_details",
      description: "Additional details of the case. (Mandatory)",
      required: true,
    },
    {//spawn one input by defuault
      label: "",
      lookupKey: "",
      description: "",
      required: false,
    },
  ];

  export default PREDEFINED_CUSTOM_ENDPOINTS;
  